import React, { Fragment, useState } from "react";
import { MdOutlineInfo } from "react-icons/md";
import { Popover } from 'react-tiny-popover'
import './index.scss';

const Content = ({ sync_errors = [], warning_errors = [] }) => (
  <div className="popover-content-wrapper">
    {sync_errors.length > 0 && (
      <div className="popover-error-block">
        <div className="popover-error-title">Please resolve the below issues for proper tracking:</div>
        <ul>
          {sync_errors.map((err, idx) => (
            <li key={idx}>{err}</li>
          ))}
        </ul>
      </div>
    )}
    {warning_errors.length > 0 && (
      <div className="popover-warning-block">
        <div className="popover-warning-title">Warning: Some features of tracking might not be functional due to below errors</div>
        <ul>
          {warning_errors.map((err, idx) => (
            <li key={idx}>{err}</li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

const InfoPopover = (props) => {
    const {sync_errors , warning_errors} = props;
    if ((!sync_errors || sync_errors.length === 0) && (!warning_errors || warning_errors.length === 0)) {
      return null;
    }
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);


    const handleMouseEnter = () => {
      setIsPopoverOpen(true);
    };
    const handleMouseLeave = () => {
      setIsPopoverOpen(false)
    };

    return (
      <Fragment>
        <Popover
          isOpen={isPopoverOpen}
          positions={["left"]}

          content={
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              <Content sync_errors={sync_errors} warning_errors={warning_errors} />
            </div>
          }
        >
          <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ display: 'inline-block', cursor: 'pointer' }}
          >
            <MdOutlineInfo className="info-popover-icon" />
          </div>
        </Popover>
      </Fragment>
    );
};

export default InfoPopover;
